import Hero from '../hero/Hero.js'
const Home = ({ movies }) => {
    return (<Hero movies={movies} />

    )
}
export default Home;